React = require 'react'
ReactDOM = require 'react-dom'
ReactBacon = require 'react-bacon'
{ Icon } = require 'react-fa'
List = require 'models/list'
PropTypes = require 'prop-types'
createReactClass = require 'create-react-class'

UserSettingsModal = require 'components/settings'
SoundService = require 'components/sound'

QuickSearch = require 'views/orders/quick_search'
Sidebar = require 'views/sidebar'

userStore = require 'stores/user'
listStore = require 'stores/lists'
uiStore = require 'stores/ui'

{ withRouter, Redirect, Link } = require 'react-router-dom'
{ Button, NavbarBrand, Navbar, Nav, Collapse, Dropdown, UncontrolledDropdown,
         DropdownToggle, DropdownMenu, DropdownItem, NavItem , NavbarToggler } = require 'reactstrap'

PageHeader = createReactClass
  displayName: 'PageHeader'
  mixins: [ReactBacon.BaconMixin]

  getInitialState: ->
    loggedIn: false
    isOpen: false

  componentWillMount: ->
    @plug userStore.loggedIn, 'loggedIn'

  onHandleSettings: ->
    @props.history.push "/settings"

  onHandleProfile: ->
    window.open "#{CHEF_URL}/#/profile"

  onHandleLogout: ->
    userStore.logout()
    window.location.reload()

  onToggleSidebar: ->
    uiStore.toggleSidebar()

  toggle: ->
    @setState isOpen: not (@state.isOpen)

  render: ->
    <Navbar expand = "lg">
      <NavbarBrand className="mr-auto">
        <Button onClick = {() => window.location.href = "/"}>
          <svg width="126px" height="30px" viewBox="0 0 126 37" version="1.1" data-reactid="6">
            <g id="zuppler-logo-light" data-reactid="7">
              <path id="zupr" style={opacity:0.6, fill:"#FFFFFF"} d="M14 18.9 L5.4 18.9 L14.9 6.8 C15.8 5.7 15 4.1 13.7 4.1 L1.7 4.1 C0.8 4.1 0.1 4.9 0.1 5.8 C0.1 6.7 0.8 7.4 1.7 7.4 L10.3 7.4 L0.8 19.5 C-0 20.6 0.7 22.2 2.1 22.2 L14 22.2 C14.8 22.2 15.6 21.4 15.6 20.5 C15.6 19.6 14.8 18.9 14 18.9 ZM47 4.1 C42.1 4.1 38.2 8.2 38.2 13.2 L38.2 27.9 C38.2 28.8 38.9 29.6 39.8 29.6 C40.7 29.6 41.4 28.8 41.4 27.9 L41.4 20.1 C42.9 21.4 44.9 22.2 47 22.2 C51.9 22.2 55.9 18.2 55.9 13.2 C55.9 8.2 51.9 4.1 47 4.1 ZM47 18.9 C44 18.9 41.6 16.5 41.4 13.2 C41.4 10 43.9 7.4 47 7.4 C50.1 7.4 52.6 10 52.6 13.2 C52.6 16.3 50.1 18.9 47 18.9 ZM34.1 4.1 C33.2 4.1 32.5 4.9 32.5 5.8 C32.5 5.9 32.5 5.9 32.5 6.6 C32.5 9.1 32.5 9.1 32.5 13.2 C32.5 16.5 30 18.9 26.9 18.9 C23.8 18.9 21.3 16.3 21.3 13.2 C21.3 10.3 21.3 10.3 21.3 8.2 C21.3 6.2 21.3 6.2 21.3 5.8 C21.3 4.9 20.6 4.1 19.7 4.1 C18.8 4.1 18.1 4.9 18.1 5.8 L18.1 13.2 C18.1 18 21.9 22.2 26.9 22.2 C31.8 22.2 35.8 18.3 35.8 13.2 L35.8 6.6 L35.8 5.8 C35.8 4.9 35 4.1 34.1 4.1 ZM117.3 5 C114.2 4.2 111.1 4.9 108.9 6.8 L108.9 5.8 C108.9 4.9 108.2 4.1 107.3 4.1 C106.4 4.1 105.7 4.9 105.7 5.8 L105.7 20.5 C105.7 21.4 106.4 22.2 107.3 22.2 C108.2 22.2 108.9 21.4 108.9 20.5 L108.9 14.3 C108.9 14.2 108.9 14.1 108.9 14 C108.9 9.7 112.5 7.2 116.6 8.2 C117.4 8.4 118.3 7.9 118.5 7 C118.7 6.1 118.2 5.2 117.3 5 ZM121.9 6.6 L121.9 4.5 L121 4.5 L121 4.1 L123.4 4.1 L123.4 4.5 L122.5 4.5 L122.5 6.6 L121.9 6.6 ZM123.4 6.6 L123.4 4.1 L124.1 4.1 L124.6 5.8 L125 4.1 L125.8 4.1 L125.8 6.6 L125.3 6.6 L125.3 4.7 L124.8 6.6 L124.3 6.6 L123.8 4.7 L123.8 6.6 L123.4 6.6 Z" data-reactid="8">
              </path>
              <path style = {fill:"#FFFFFF"} id="ple" d="M75.9 13.2 C75.9 8.2 72 4.1 67.1 4.1 C62.2 4.1 58.3 8.2 58.3 13.2 C58.3 13.3 58.3 13.5 58.3 13.6 C58.3 13.6 58.3 13.7 58.3 13.7 C58.3 13.7 58.3 13.8 58.3 13.8 C58.3 14.3 58.4 14.8 58.4 15.4 C58.9 18.4 60.3 21.5 62.3 24.6 C63.2 26 64.1 27.2 65 28.4 C65.3 28.8 65.7 29.1 65.9 29.4 C66.1 29.6 66.2 29.8 66.3 29.8 C66.9 30.5 67.9 30.5 68.6 29.9 C69.2 29.3 69.2 28.2 68.6 27.6 C68.6 27.5 68.5 27.4 68.3 27.3 C68.1 27 67.8 26.6 67.5 26.3 C66.7 25.2 65.8 24 65 22.8 C64.8 22.4 64.6 22.1 64.3 21.7 C65.2 22 66.1 22.2 67.1 22.2 C72 22.2 75.9 18.1 75.9 13.2 L75.9 13.2 ZM61.5 13.6 C61.5 13.4 61.5 13.3 61.5 13.2 C61.5 10 64 7.4 67.1 7.4 C70.2 7.4 72.7 10 72.7 13.2 C72.7 16.3 70.2 18.9 67.1 18.9 C64.1 18.9 61.7 16.6 61.5 13.6 ZM83.2 22.2 L82.4 22.2 L82.4 1.7 C82.3 0.8 81.6 0 80.8 0 C79.9 0 79.2 0.8 79.2 1.7 L79.2 23.8 C79.2 24.7 79.9 25.5 80.8 25.5 L83.2 25.5 C84.1 25.5 84.8 24.7 84.8 23.8 C84.8 22.9 84.1 22.2 83.2 22.2 ZM92.8 29.2 C92.2 28.6 91.2 28.5 90.5 29.2 C89.5 30.1 88.5 31 87.5 31.6 C83.5 34 79.3 34.2 75.4 33.1 C74.9 33 74.5 32.8 74.1 32.7 C73.9 32.6 73.8 32.5 73.7 32.5 C72.9 32.1 72 32.5 71.6 33.3 C71.2 34.1 71.5 35.1 72.3 35.5 C72.8 35.7 73.5 36 74.5 36.3 C79.2 37.6 84.3 37.4 89.1 34.4 C90.4 33.6 91.6 32.7 92.8 31.5 C93.4 30.9 93.4 29.9 92.8 29.2 ZM94.4 4.1 C89.5 4.1 85.6 8.2 85.6 13.2 C85.6 18.1 89.5 22.2 94.4 22.2 C95.3 22.2 96 21.4 96 20.5 C96 19.6 95.3 18.9 94.4 18.9 C91.9 18.9 89.7 17.2 89 14.8 L101.7 14.8 C102.6 14.8 103.3 14.1 103.3 13.2 C103.3 8.2 99.3 4.1 94.4 4.1 ZM94.4 7.4 C97 7.4 99.1 9.1 99.8 11.5 L89 11.5 C89.7 9.1 91.9 7.4 94.4 7.4 L94.4 7.4 Z" data-reactid="9">
              </path>
            </g>
          </svg>
        </Button> 2β
      </NavbarBrand>
      <NavbarToggler onClick={@toggle} />
      <Collapse isOpen={@state.isOpen} navbar>
        <QuickSearch />
        { @renderUserMenu() }
      </Collapse>
    </Navbar>

  renderUserMenu: ->
    if @state.loggedIn
      <Nav className="hidden-sm hidden-xs" key={0} navbar>
        <UncontrolledDropdown nav inNavbar key={1}>
          <DropdownToggle nav caret id="user-location">
            {userStore.name() || 'Zuppler'}
          </DropdownToggle>
          <DropdownMenu>
          <DropdownItem key="settings" onClick={@onHandleSettings}>Settings</DropdownItem>
          <DropdownItem divider />
          <DropdownItem key="profile" onClick={@onHandleProfile}>My Profile</DropdownItem>
          <DropdownItem key="logout" onClick={@onHandleLogout}>Logout</DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </Nav>

module.exports = withRouter(PageHeader)
